
import layerEvents from "../utils/layerEvents";
import { Button, Col, Row, Dropdown, Form, Card} from "react-bootstrap";
import Select from "react-select";
import { PencilSimple,Lightning, Windmill, BatteryCharging, BatteryFull, Spiral, Ruler, Crosshair, X, Info, Eye, Trash, DotsThreeVertical, Wind, Calculator, Warning, CircleNotch, Plus, Bulldozer,ArrowsOutLineVertical,ArrowsOutLineHorizontal, Bridge, WarningCircle    } from "@phosphor-icons/react";
import DataTable from 'react-data-table-component';
import vindrApi from "../utils/vindrapi";
import EditNow from "../components/EditNow";
import DoNowButton from "../components/DoNowButton";
import ReactDOM from "react-dom/client";
import boundaryMode from "../utils/boundaryMode";
import TurfArea from '@turf/area';
import TurfBuffer from '@turf/buffer';
import TurfLength from '@turf/length';
import TurfKinks from '@turf/kinks';
import {formatArea, formatDistance} from "../utils/functions";
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import drawTheme from "../utils/drawUtilsTheme";
import LayerBoundary		from "../classes/LayerBoundary";
import {polygon} from '@turf/helpers';

class ToolBoundary {

	tabIndex			= null;
	highlightedOnList	= [];
	hiddenBoundarys	= [];
	allHidden			= false;
	
	turbineTypes		= [];
	turbineHeights		= [];
	modified			= false;
	contextMenu			= null;
	lastSelection		= null;
	
	type				= 'boundary'
	
	constructor(p) {
		this.parent = p;
		this.draw	= p.draw.draw;
		this.tc		= p;
		
	}

	init(){
		this.display();
		this.setEventHandlers();
		this.tc.map.getContainer().classList.add("cursor-boundary");
		this.stackDrawLayers();
		this.closeInvalidPanel();
		this.checkScenario();
		
	}
	exit(){
		if(this.parent.serviceBar.current)
			this.parent.serviceBar.current.clear(this.tabIndex);
		this.tabIndex = null;
		this.removeEventHandlers();
		
		this.parent.map.getContainer().classList.remove("cursor-boundary");
		
		//unhide all boundarys
		this.hideAll = true;
		this.handleHideAllBoundarys();
		this.unsetStyle();
		this.closeInvalidPanel();
	}
	
	stackDrawLayers = () =>{
		
		drawTheme.forEach((l)=>{
			if(this.tc.map.getLayer(l.id+".cold"))
				this.tc.map.moveLayer(l.id+".cold");
			if(this.tc.map.getLayer(l.id+".hot"))
				this.tc.map.moveLayer(l.id+".hot");
		});
		
	}
	setEventHandlers(){
		
		if(!this.parent)
			return;
		
		this.tc.map.on('click', this.handleClick);
		
		this.tc.map.on('draw.update', this.handleUpdate);
		
		this.tc.map.on('mouseenter', [LayerBoundary.layerId], this.handleMouseEnter);
		this.tc.map.on('mouseleave', [LayerBoundary.layerId], this.handleMouseLeave);
		
		this.tc.map.on('mouseenter', [LayerBoundary.layerId], this.handleCursorChange);
		this.tc.map.on('mouseleave', [LayerBoundary.layerId], this.handleCursorChange);
		
		
		this.tc.map.on("scenario.updated", this.checkScenario);
		
	}
	removeEventHandlers(){
		if(!this.parent)
			return;
		
		this.tc.map.off('click', this.handleClick);
		this.tc.map.off('draw.update', this.handleUpdate);
		
		this.tc.map.off('mouseenter', [LayerBoundary.layerId], this.handleMouseEnter);
		this.tc.map.off('mouseleave', [LayerBoundary.layerId], this.handleMouseLeave);
		
		
		this.tc.map.off('mouseenter', [LayerBoundary.layerId], this.handleCursorChange);
		this.tc.map.off('mouseleave', [LayerBoundary.layerId], this.handleCursorChange);
		
		this.tc.map.off("scenario.updated", this.checkScenario);
	}
	handleClick = (e) => {
		
		if(this.tc.secondaryHandler)
			return;
		
		var features = this.tc.map.queryRenderedFeatures(e.point, {layers:[LayerBoundary.layerId]});
		
		if(this.tc.handler.constructor.name == "ToolBoundaryAdd" || !this.tc.scenario.boundary.geometry.coordinates.length)
			return;
		
		
		var clickedBoundary = features && features[0] ? features[0].properties.boundaryid : false;

		this.exit();
		this.tc.handler = new ToolBoundaryAdd(this.tc, clickedBoundary);
		this.tc.handler.init(e);
		
	}

	handleCursorChange = (e)=>{
		this.tc.map.getContainer().classList[e && e.type == 'mouseenter' ? 'add' : 'remove']("cursor-pointer");
		
	}
	handleMouseEnter = (e)=>{
		if(!e.features.length)
			return;
		
		var boundaryId = e.features[0].properties.boundaryid;
		
		if(boundaryId>-1){
			this.highlightedOnList = [boundaryId];
		}

		
		this.display();
	}
	
	
	handleMouseLeave = (e)=>{
		this.highlightedOnList = [];
		this.display();
	}
	
	highlightOnMap = (row)=>{
		
		this.tc.map.setFeatureState({id:100000000+(row.boundaryid ?? row?.properties?.tempid), source:LayerBoundary.sourceId}, {hover:true});
		
	}
	deHighlightOnMap = (row)=>{
		
		this.tc.map.setFeatureState({id:100000000+(row.boundaryid ?? row?.properties?.tempid), source:LayerBoundary.sourceId}, {hover:false});
		
	}
	handleEdit = (row) => {
		
		const boundaryId = row.boundaryid ?? row?.properties?.tempid;
		
		if(boundaryId === false)
			return;
		
		
		setTimeout(()=>{
			
			this.tc.handler = new ToolBoundaryAdd(this.tc, boundaryId);
			this.tc.handler.init();
			
		}, 50);
		
		
	}
	handleCreate = (e) => {
		//it's a new boundary polygon
		if (e.features && e.features[0].id){
			ToolBoundary.lastSelection = {id: e.features[0].id, type: e.features[0].properties.type}
			this.handleUpdate(e, e.features[0].id);
		}
	
		this.exit();
		
		this.handleEdit({boundaryid:(this.tc.scenario.boundary.geometry.coordinates.length-1)});	
		
	}
	handleDelete = (e) => {
		if (e.features && e.features[0].id ){
			this.handleUpdate(e, e.features[0].id, true);
			this.resetLayer();
			this.exit();
			this.boundaryModeForce();
		}
	}
	handleDeleteFromList(e, boundaryId){
		this.handleUpdate(e, boundaryId, true);
		this.resetLayer();
		this.exit();
		this.boundaryModeForce();
	}
	handleSelect = (e, row) => {
		const id = "boundaryid";
		if(!this.selected)
			this.selected = [];
		const idx = this.selected.findIndex((a)=>{return a[id] == row[id]});
		if(idx !== -1){
			this.selected.splice(idx, 1);
		}
		else{
			this.selected.push(row);
		}
		this.display();
	}
	handleBulkDelete = () => {
		if(!this.selected || !this.selected.length)
			return;
		this.selected.forEach((row) => {
			this.handleDeleteFromList(null, row.boundaryid);
		});
		this.selected = [];
		this.display();
	}
	handleUpdate = (e, pl, del) => {
		
		if(e.action == 'move'){
			console.log('move');
			return;
		}
		//check for boundary update
		var npl = null;
		var self = this;
		
		var nplid = pl ? parseInt(pl.toString().replace(/^\D+/g, '')) : e.features[0].id.toString().replace(/^\D+/g, '');
		
		if(del)
			npl = {properties:{boundaryid:nplid} };

		
		if(del || (npl = this.draw.get(pl) ?? e.features[0])){
			
			var s = {...this.tc.scenario};
			const boundaryId = npl.properties.boundaryid ?? npl.properties.tempid ?? false;
			
			if(boundaryId !== false) {
			

				if(boundaryId>-1){
					if(del){
						s.boundary.geometry.coordinates.splice(boundaryId, 1);	
					}
					else if(npl.geometry){
						s.boundary.geometry.coordinates[boundaryId] = npl.geometry.coordinates;
					}
				}
				if(npl.properties.tempid)
					delete npl.id;
			}
			else {
				delete npl.id;
				npl.properties = {tempid : Math.floor(1000000 + Math.random() * 10000000)};
					
				s.boundary.geometry.coordinates.push(npl.geometry.coordinates);
			}
			
			
			
			s.kinks = this.checkBoundary(npl);
			s.modified = 1;
			
			this.tc.setScenario(s);
			this.tc.record().add(s);
		}
	}
	handleSelectionChange = (e) => {	
		//var features = this.map.queryRenderedFeatures(e.point);
		if(!this.parent || !this.parent.scenario || !this.parent.scenario.scenario_id //check if is main scenario
		){
			this.parent.draw.draw.changeMode('simple_select');
		}
		//check if boundary is deselected or a diferent boundary
		
		if (ToolBoundary.lastSelection && (!e.features.length || e.features[0].id != ToolBoundary.lastSelection.id)){
			this.finishLastEdit();
		}
		//check if boundary is selected
		if (e.features.length && e.features[0].properties && ['boundary', 'road'].includes(e.features[0].properties.type) ){
			ToolBoundary.lastSelection = {id: e.features[0].id, type: e.features[0].properties.type};
			return;
		}

	}
	
	finishLastEdit(e){
		if (ToolBoundary?.lastSelection?.id){
			this.handleUpdate(e, ToolBoundary.lastSelection.id);
		}
		ToolBoundary?.currentObj?.exit();
	}
	
	highlightOnList = (id) => {
		this.highlightedOnList.push(parseInt(id));
		
		this.highlightedOnList = [...new Set(this.highlightedOnList)];
		
		this.display();
	}
	deHighlightOnList = (id) => {

		const index = this.highlightedOnList.indexOf(parseInt(id));
		if (index > -1) { 
			this.highlightedOnList.splice(index, 1); 
		}
		this.display();
	}

	pName(row, index){
		return row.name ? row.name : 'Boundary '+ (index+1);
		
	}
	handleUpdateName = (val, boundaryId) => {
		
		var s = {...this.tc.scenario};
		

		var idx = s.boundarys.findIndex((p)=>{
			return p.boundaryid == boundaryId || (p.properties && p.properties.tempid == boundaryId);
		});

		if(idx>-1){
			s.boundarys[idx].name = val;
		}
		//this.tc.draw.drawPowerLines(s);
		this.resetLayer();
		//issue exit command to refresh viewport (weird bug not deleting the pl linestring


		s.modified = 1;

		this.tc.setScenario(s);
		this.tc.record().add(s);
	}
	setHideAll(value){
		this.hideAll = value;
		this.display();
	}

	isSelectedOnList = (row)=>{
		return this.highlightedOnList.includes(row.boundaryid);
	}
	
	display(){
		if(this.parent.serviceBar.current)
			this.tabIndex =	this.parent.serviceBar.current.inject(this.render(), this.tabIndex);
	}
	
	contextMenuAdd(map_event){
		return (
			<button className="btn" onClick={(e)=>{this.parent._addTurbineHandler(map_event); this.closeContextMenu();}}><Plus size={20} /> Add Boundary</button>
		);
	}
	contextMenuDelete(map_event){
		return (
			<button className="btn" onClick={(e)=>{this.parent._remTurbineHandler(map_event); this.closeContextMenu();}}><Trash size={20} /> Remove Boundary</button>
		);
	}
	
	handleHideAllBoundarys = () => {
		if(!this.hideAll){
			this.hiddenBoundarys = this.parent.scenario.boundary.geometry.coordinates.map((t, idx)=>{
				this.toggleBoundary(idx, true, true);
				return idx;
			});
			this.hideAll = true;
		}
		else{
			const copy = this.hiddenBoundarys.slice(0);
			copy.forEach((t)=>{this.toggleBoundary(t, false, true);});
			this.hideAll = false;
			
		}
	}
	handleToggleBoundary = (e, boundaryid, f, dontRefresh)=>{
		e.stopPropagation();
		this.toggleBoundary(boundaryid, f, dontRefresh);
	}	
		
	toggleBoundary = (boundaryid, f, dontRefresh) => {
		
		const force = typeof f == "boolean" ? f : 'undefined';
		const hide = document.querySelector("#bndr_"+boundaryid).classList.toggle("opacity-25", typeof force == "boolean" ? force : undefined);
		
		this.tc.map.setFeatureState({
            source: LayerBoundary.sourceId,
            id: boundaryid
        }, {invisible:(force != 'undefined' ? force : hide)});
		
		
		
		if(!hide){
			const index = this.hiddenBoundarys.indexOf(boundaryid);
			if (index > -1) {
			  this.hiddenBoundarys.splice(index, 1);
			}
		}
		else
			this.hiddenBoundarys.push(boundaryid);
		
		if(!this.hiddenBoundarys.length){
			this.allHidden = false;
		}
		if(!this.hiddenBoundarys.length == this.tc.scenario.boundary.geometry.coordinates.length){
			this.allHidden = true;
		}
		
	}
	resetLayer = ()=>{
		this.tc.infoLayers.current.resetSystemLayer("boundary");
		
	}
	setStyle(){
		
		this.tc.map.setPaintProperty('gl-draw-polygon-and-line-vertex-inactive.hot', 'circle-color', LayerBoundary.defaultColor);
		this.tc.map.setPaintProperty('gl-draw-polygon-and-line-vertex-inactive.cold', 'circle-color', LayerBoundary.defaultColor);
	}
	
	unsetStyle(){
		
		this.tc.map.setPaintProperty('gl-draw-polygon-and-line-vertex-inactive.hot', 'circle-color', '#5078FF');
		this.tc.map.setPaintProperty('gl-draw-polygon-and-line-vertex-inactive.cold', 'circle-color', '#5078FF');
	}
	checkScenario = () => {
		if(this.tc.scenario.kinks)
			this.openInvalidPanel();
		else
			this.closeInvalidPanel();
	}
	checkBoundary(b){
		var poly = polygon(b.geometry.coordinates);

		var kinks = TurfKinks(poly);
		
		if(kinks.features.length)
			this.openInvalidPanel();
		else
			this.closeInvalidPanel();
		
		return kinks.features.length;
	}
	openInvalidPanel = ()=>{
		
		var wrp = document.createElement("div");
		wrp.className = "boundaryModePanel";
		
		this.closeInvalidPanel();
		
		this.tc.map.getContainer().appendChild(wrp);
		

		ReactDOM.createRoot(wrp).render(
			<Card bg="danger" className="invalid-panel">
				<Card.Body>
					<Card.Title><WarningCircle size={16} weight="bold" /> Invalid boundary</Card.Title>
					<Card.Text>
						Your boundary contains overlapping points, you won't be able to save scenario before it's corrected.
						<br />
						<a onClick={()=>{this.tc.undo()}}>Undo Change</a>
					</Card.Text>
				</Card.Body>
			</Card>	
		);
		
	}
	closeInvalidPanel() {
		
		if(!this.tc)
			return;
		var a = false;
		if(a = this.tc.map.getContainer().querySelector(".boundaryModePanel")){
			a.remove();
		}
		
		
	}
	
	render(){
		const {getters} = this.parent.draw.context;
		
		var lines = this.parent.scenario.boundary.geometry.coordinates.map((c, idx)=>{
			
			var poly = polygon([...c]);
			var area = TurfArea(poly);
			
			return {
				name: 'Boundary ' + (idx+1),
				number: idx+1,
				area: formatArea(area),
				boundaryid: idx
			}
		});
		return (
			
			<div className={"project-boundaries "}>
				<div className="title">
					Boundaries
					{/*<span onClick={(e)=>{this.parent.exit()}} 	className="btn btn-close alt btn-sm float-end"><X size={16} /></span>*/}
				</div>
				<div className="scroll">
					<div className="content p-0">

						<DataTable key={123}
							data={lines}
							columns={
								[
									{
										name:<Eye onClick={this.handleHideAllBoundarys} className={""+(this.allHiden ? 'opacity-25' : '')} size={16} />,
										id:'userid',
										selector: row => row.userid,
										format: (row, index) =>	(<Eye onClick={(e)=>{this.handleToggleBoundary(e, index, undefined, false)}} id={"bndr_"+(index)} data-id={(index)}  className={""+(this.hiddenBoundarys.includes(index) || this.allHidden ? 'opacity-25' : '')} size={16} />),
										width:"28px !important",
										style: {
											padding: '0',
										}
									},
									{
										name:'',
										selector: row => row.name,
										format: (row,index) => ( <label className="checkbox-pad"><Form.Check type="checkbox" id={"check-"+row.boundaryid} checked={this.selected && this.selected.some((a)=>a.boundaryid == row.boundaryid)} onClick={(e)=>{this.handleSelect(e, row);}} /></label>),
										width:"25px",
										style: {
											padding: '0px !important',
											width:'25px'
										}
									},
									{
										name:'NAME',
										selector: (row,index) => {return row.name},
										format: (row,index) => (<EditNow id={'boundary-'+(index)} value={this.pName(row,index)} onClick={(e)=>{this.handleEdit(row)}} editable={true} onUpdate={(val)=>{this.handleUpdateName(val, index)}} />),
										sortable:true,
										width:"100%",
										//maxWidth:"160px !important",
									},
									{
										name:'Area',
										selector: row => row.area,
										format: (row,index) => row.area,
										sortable:true,
										width:"100%",
										center:true,
										//maxWidth:"160px !important",
									},

									{
										name:'',
										cell: row => (
											<div className="context-menu" data-tag="allowRowEvents">
													<Dropdown className="minimal">
														<Dropdown.Toggle className="p-0 px-1" variant="default">
															<DotsThreeVertical size={16} />
														</Dropdown.Toggle>
														<Dropdown.Menu>
															<Dropdown.Item href="#" onClick={(e)=>{ this.handleEdit(row);   }}><PencilSimple size={16} /> Edit boundary</Dropdown.Item>
															<Dropdown.Item href="#" onClick={(e)=>{ this.handleDeleteFromList(e, (row.boundaryid ?? row.properties.tempid)); }} className="text-danger" ><Trash size={16} /> Remove boundary</Dropdown.Item>
														</Dropdown.Menu>
													</Dropdown>
											</div>
										),
										width:"20px !important",
										style: {
										}
										//minWidth:"160px !important",
										//maxWidth:"160px !important",
									}
								]
							}
							customStyles={{
								headCells:{
									style: {
										padding:'.5rem .3rem',
										minWidth:'0px !important',
										boxSizing:'content-box',
										fontWeight:'bold'
									}
								},
								cells:{
									style: {
										padding:'.5rem .3rem',
										minWidth:'0px !important',
										boxSizing:'content-box',
										fontSize: 'var(--bs-body-font-size);',
										color:'var(--bs-body-color)',
										'&:last-child':{paddingRight:'1rem'}
									}
								},
								rows:{
									style: {
										minHeight:"0",
									},
									selectedHighlightStyle:{
										backgroundColor:'red'
									}
								}
							}}
							onRowMouseEnter={this.highlightOnMap}
							onRowMouseLeave={this.deHighlightOnMap}
							onRowClicked={this.handleEdit }
							selectableRowSelected={r=>this.isSelectedOnList(r)}
							highlightOnHover
							selectableRowsHighlight
							pointerOnHover
							sortIcon={<i className="ri-expand-up-down-line" />}
							noDataComponent={

								<Row className="p-0 py-3 m-0">

									<Col xs="1 pe-0">
										<Info className="text-danger" size={15} />
									</Col>
									<Col xs="11 ps-0">
										<b>Please note:</b> There are currently no turbines placed in this scenario. Please place turbines on the map to calculate the Annual Energy Production (AEP).
									</Col>



								</Row>
							}
						/>


						{this.selected && !!this.selected.length &&
							<Row className="p-3 batch-action">
								<Col xs="6">
									{this.selected.length} Items selected
								</Col>
								<Col xs="6 text-end">
									<Button variant="primary" onClick={this.handleBulkDelete}>Delete</Button>
								</Col>
							</Row>
						}
					</div>	

				</div>
				
			</div>	
			
		);
		
	}
}


class ToolBoundaryAdd extends ToolBoundary {

	tabIndexAdd = null;
	boundaryId = false;
	
	constructor(p, boundaryId) {
		super(p);
		//this.tc = this.parent.parent;
		this.scenario = this.tc.scenario;
		this.draw = this.tc.draw.draw;
		this.boundaryId = boundaryId;
		//this.get();
		this.area = 0;
		this.length = 0;
		
		return this;
	}
	
//	get(){
////		const idx = this.scenario.boundary.findIndex((p)=>{
////			return p.boundaryid == this.boundaryId || (p.properties && p.properties.tempid && p.properties.tempid == this.boundaryId);
////		});
//		
//		if(this.boundaryId > -1){
//			this.objIdx = this.boundaryId;
//			this.obj = this.scenario.boundary.geometry.coordinates[idx];
//			
//		}
//		else{
//			this.obj = {
//				name: 'Boundary '+(this.scenario.boundary.geometry.coordinates.length+1),
//			}
//		}
//		
//	}
	loadBoundary(boundaryId){
		//find clicked boundary 
		if(this.boundaryId === false)
			return;
		
		var plCoords = this.scenario.boundary.geometry.coordinates[this.boundaryId];

		const b	= {};
		b.id = 'boundary_'+this.boundaryId;
		b.type = 'Feature';
		b.properties = {
			type:'boundary', 
			boundaryid: this.boundaryId,
			color: LayerBoundary.defaultColor
		};
		b.geometry = {
			type : "Polygon",
			coordinates: plCoords
		};
		

		this.draw.add(b);
		
		ToolBoundary.lastSelection = {id: b.id, type: this.type};
		this.draw.changeMode('simple_select', { featureIds: [b.id] });
		this.draw.changeMode('direct_select', {
			featureId: b.id,
			coordPath: "0.0",
			startPos: {lng:b.geometry.coordinates[0][0][0], lat:b.geometry.coordinates[0][0][1]}
		});
		this.removeFeature(this.boundaryId);
		
		this.stackDrawLayers();
		this.setStyle();
	}
	
	init(e){
		
		
//		if(this.tc.serviceBar.current)
//			this.tabIndexAdd = this.tc.serviceBar.current.inject(this.render());
//		
		this.tc.map.getContainer().classList.add("cursor-boundary");
		this.draw.changeMode('simple_select', { featureIds: [] });

		if(this.boundaryId !== false){
			this.loadBoundary();
		}
		else{
			
			this.draw.changeMode('boundary_mode', {
				boundaries: this.tc.scenario.boundary,
				toolBoundary: this,
				startCoordinate: [e.lngLat.lng, e.lngLat.lat]
			});
			this.setStyle();
		}
		this.setEventHandlers();
		this.display();
		
	}
	exit(){
		if(this.tc.serviceBar.current)
			this.tc.serviceBar.current.clear(this.tabIndexAdd);
		this.removeEventHandlers();
		this.tc.map.getContainer().classList.remove("cursor-boundary");
		//this.closeDrawPanel();
		this.removeDrawLayer()
		this.resetLayer();
		this.tabIndexAdd = null;
		this.objIdx = null;
		ToolBoundary.lastSelection = null;
		
		this.unsetStyle();
	}
	setEventHandlers(){
		
		if(!this.tc)
			return;
		
		this.removed = 1;
		
		this.tc.map.on('draw.create', this.handleCreate);
		this.tc.map.on('draw.delete', this.handleDelete);
		this.tc.map.on('draw.selectionchange',	this.handleSelectionChange);
		this.tc.map.on('draw.update', this.handleUpdate);
		
		//this.tc.map.on('mousemove',		this.calculate);

		this.tc.map.on('mouseenter',	[LayerBoundary.layerId], this.handleMouseEnter);
		this.tc.map.on('mouseleave',	[LayerBoundary.layerId], this.handleMouseLeave);
		
		this.tc.map.on("scenario.updated", this.checkScenario);
	}
	removeEventHandlers(){
		if(!this.parent || !this.removed)
			return;
		this.removed = 0;
		
		this.tc.map.off('draw.create', this.handleCreate);
		this.tc.map.off('draw.delete',	this.handleDelete);
		this.tc.map.off('draw.selectionchange',	this.handleSelectionChange);
		this.tc.map.off('draw.update', this.handleUpdate);
		
		//this.tc.map.off('mousemove',	this.calculate);
		
		this.tc.map.off('mouseenter',	[LayerBoundary.layerId], this.handleMouseEnter);
		this.tc.map.off('mouseleave',	[LayerBoundary.layerId], this.handleMouseLeave);
		super.removeEventHandlers();
		
	}
	
	removeFeature(id){
		var data = this.tc.map.getSource(LayerBoundary.sourceId)._options.data;
		//remove the original line
		var idx = data.features.findIndex((p)=>{return p.properties.boundaryid == id});
		if(idx>-1)
			data.features.splice(idx, 1);
		
		this.tc.map.getSource(LayerBoundary.sourceId).setData(data);
	}
	boundaryModeForce = () => {
		
		this.tc.handler = new ToolBoundary(this.tc);
		this.tc.handler.init();
		
	}
	handleClick = ()=>{
		
	}
	closeDrawPanel() {
		
		if(!this.tc)
			return;
		var a = false;
		if(a = this.tc.map.getContainer().querySelector(".boundaryModePanel")){
			a.remove();
		}
		
		
	}
	removeDrawLayer(){
		if(ToolBoundary.lastSelection && this.draw.get(ToolBoundary.lastSelection.id)){
			let id = ToolBoundary.lastSelection.id;
			
			setTimeout(()=>{
				
				this.draw.delete(id);
			}, 10);
		}
	}
	handleSelectionChange = (e)=>{
		if(!e.features.length){
			//remove all editable drawings and switch to view mode

			this.exit();
			this.boundaryModeForce();
			//this.tc.draw.drawPowerLines(this.scenario, this.tc);
			//issue exit command to refresh viewport (weird bug not deleting the pl linestring
			this.resetLayer();
			this.tc.map.getContainer().classList['remove']("cursor-pointer");
			
		}
	}
	
	handleOnClose = (e)=>{
		this.exit();
		
	}
	handleUpdate(e, pl, del){
		
		super.handleUpdate(e, pl, del);
		this.removeBufferLayer();
		
	}
	
	openDrawPanel = ()=>{
		
		var wrp = document.createElement("div");
		wrp.className = "boundaryModePanel";
		
		this.closeDrawPanel();
		
		this.tc.map.getContainer().appendChild(wrp);
		

		//ReactDOM.createRoot(wrp).render(<PowerRoadsPanel setup={{open:true, obj:this.obj}} handler={this} onClose={this.handleOnClose} onNameChange={this.handleNameChange} onColorChange={this.handleColorChange} onWidthChange={this.handleWidthChange} />	);
		
	}
	

}


export { ToolBoundary, ToolBoundaryAdd};